/**
 * lib/storefront/wick_guide/wax.js
 */

import keys from 'lodash/keys'

class Wax {
  constructor(waxName, waxUrl) {
    this.name = waxName;
    this.url = waxUrl;
    this._wicks = {};
    this.rowsRequired = 1;
  }

  get sizes() {
    return keys(this._wicks);
  }

  findWick(size) {
    return this._wicks[size];
  }

  addWick(size, candleWick) {
    if (candleWick.multipleRows) {
      this.rowsRequired = 2;
    }

    this._wicks[size] = candleWick;
  }
}

export default Wax;
